import { inject, Injectable, signal } from '@angular/core';
import { ActionItemDto } from '../api/api-clientInformation';
import { JsonPipe } from '@angular/common';

const STOREAGEKEY = 'action-item';

@Injectable({
  providedIn: 'root'
})
export class ActionItemService {
  private _list = signal<ActionItemDto[]>(this.getData());
  private nextId = -1; // Use negative numbers for temp IDs

  public readonly list = this._list.asReadonly();

  private getData() {
    const storedData = localStorage.getItem(STOREAGEKEY) ||null;;

    return storedData ? JSON.parse(storedData) : [];

  }

  set(items: ActionItemDto[]) {
    this._list.set(items);
  }

  add(item: ActionItemDto) {
    // Assign a temporary client-side ID if it's a new item.
    if (item.id === undefined || item.id === 0) {
      item.id = this.nextId--;
    }
    this._list.update(items => [...items, item]);
    localStorage.setItem(STOREAGEKEY,JSON.stringify(this._list()));

  }

  update(updatedItem: ActionItemDto) {
    this._list.update(items => items.map(item =>
      item.id === updatedItem.id ? updatedItem : item));
  }

  remove(id: number) {
    this._list.update(items => items.filter(item => item.id !== id));
  }

  clear() {
    this._list.set([]);
  }

  getItem(id: number): ActionItemDto | undefined {
    return this.list().find(i => i.id === id);
  }
}
